var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-box"},[_c('div',{staticClass:"status-content"},[_c('div',{staticClass:"icon-container"},[_c('img',{staticClass:"icon-img",attrs:{"src":require("@/assets/info-yellow.svg"),"alt":"Info Icon"}}),_c('div',{staticClass:"status-message"},[_c('p',{staticClass:"p"},[_vm._v("This location is under review by ParkMan staff")])])])])])
}]

export { render, staticRenderFns }